var CaseInsensitiveSet = /** @class */ (function () {
    function CaseInsensitiveSet() {
        var _this = this;
        this.items = new Map();
        this.add = function (value) {
            if (value) {
                var key = value.toLowerCase();
                if (!_this.items.has(key)) {
                    _this.items.set(key, value);
                    return true;
                }
            }
            return false;
        };
        this.values = function () { return Array.from(_this.items.values()); };
    }
    return CaseInsensitiveSet;
}());
export { CaseInsensitiveSet };
//# sourceMappingURL=CaseInsensitiveSet.js.map